import initialState from './initialState'
import { LOGOUT_USER } from '../../common/redux/constants'
import { reducer as footerReducer} from './footerActions'
import { reducer as selectIncentiveReducer } from './selectIncentive/reducer'
import { reducer as getNewCommissionMonthReducer } from './getNewCommissionMonth/reducer'
import { reducer as addIncentive } from './addIncentive/reducer'
import { reducer as deleteIncentive } from './deleteIncentive/reducer'
import { reducer as clearState } from './clearState/reducer'
import { reducer as basicInformation } from './addBasicInformation/reducer'
import { reducer as createComissionPolicy } from './createComissionPolicy/reducer'
import { reducer as setStatusBorradorVigente } from './setPolicyStatus/reducer'
import { reducer as createNewCommissionMonth } from './createNewCommissionMonth/reducer'
import { reducer as  getComissionDataReducer } from './getCommissionData/reducer';
import { reducer as getCommissionsState } from './getCommissionsStates/reducer'
import { reducer as updateCommissionMonth } from './updateCommissionMonth/reducer'
import { reducer as getRangeCommissionMonth } from './getRangeCommissionMonth/reducer'
import { reducer as getIncentiveCards } from './getIncentiveCards/reducer'
import { reducer as getPossibleActionsReducer } from './getPossibleActions/reducer'
import { reducer as getCommissionsPeriods } from './getCommissionsPeriods/reducer'
import { reducer as getAllPeriods } from './getAllPeriods/reducer'
import { reducer as getAvailablePeriodsReducer } from './getAvailablePeriods/reducer'
import { reducer as generateExcelReducer } from './generateExcel/reducer'
import { reducer as getPolicy } from './getPolicy/reducer'
import { reducer as getPolicyById } from './getPolicyById/reducer'
import { reducer as patchCommissionPolicy } from './patchCommissionPolicy/reducer'
import { reducer as getBranchOfficesReducer } from './getBranchOffices/reducer'
import { reducer as cleanAvailablePeriodsReducer } from './cleanAvailablePeriods/reducer'
import { reducer as createPolicyCopyReducer } from './createPolicyCopy/reducer'
import { reducer as getCheckedIncentivesReducer } from './getCheckedIncentives/reducer'
import { reducer as updatePolicyStatusReducer } from './updatePolicyStatus/reducer'
import { reducer as addOpportunity } from './addOpportunity/reducer'
import { reducer as getStock } from './getStock/reducer'
import { reducer as clearStockOportunity } from './clearStockOportunity/reducer' 
import { reducer as deleteOpportunityRow } from './deleteOpportunityRow/reducer' 

const reducers = [
  footerReducer,
  selectIncentiveReducer,
  addIncentive,
  deleteIncentive,
  clearState,
  basicInformation,
  createComissionPolicy,
  setStatusBorradorVigente,
  getNewCommissionMonthReducer,
  createNewCommissionMonth,
  getComissionDataReducer,
  getCommissionsState,
  updateCommissionMonth,
  getRangeCommissionMonth,
  getIncentiveCards,
  getPossibleActionsReducer,
  getCommissionsPeriods,
  getAllPeriods,
  getAvailablePeriodsReducer,
  generateExcelReducer,
  getPolicy,
  getPolicyById,
  patchCommissionPolicy,
  getBranchOfficesReducer,
  cleanAvailablePeriodsReducer,
  createPolicyCopyReducer,
  getCheckedIncentivesReducer,
  updatePolicyStatusReducer,
  addOpportunity,
  getStock,
  clearStockOportunity,
  deleteOpportunityRow
];

export default function reducer(state = initialState, action = {}) {
  let newState;
    if (action.type === LOGOUT_USER) {
      // Handle cross-topic actions here
        newState = initialState;
    }
    else {
      newState = state;
    }
  return reducers.reduce((s, r) => r(s, action), newState);
}
